import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {SystemUser} from './system-user.model';
import * as SystemUserActions from './system-user.actions';

export const systemUsersFeatureKey = 'systemUsers';

export interface State extends EntityState<SystemUser> {
  // additional entities state properties
}

export const adapter: EntityAdapter<SystemUser> = createEntityAdapter<SystemUser>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});


export const reducer = createReducer(
  initialState,
  on(SystemUserActions.addSystemUser,
    (state, action) => adapter.addOne(action.systemUser, state)
  ),
  on(SystemUserActions.upsertSystemUser,
    (state, action) => adapter.upsertOne(action.systemUser, state)
  ),
  on(SystemUserActions.addSystemUsers,
    (state, action) => adapter.addMany(action.systemUsers, state)
  ),
  on(SystemUserActions.upsertSystemUsers,
    (state, action) => adapter.upsertMany(action.systemUsers, state)
  ),
  on(SystemUserActions.updateSystemUser,
    (state, action) => adapter.updateOne(action.systemUser, state)
  ),
  on(SystemUserActions.updateSystemUsers,
    (state, action) => adapter.updateMany(action.systemUsers, state)
  ),
  on(SystemUserActions.deleteSystemUser,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(SystemUserActions.deleteSystemUsers,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(SystemUserActions.loadSystemUsers,
    (state, action) => adapter.setAll(action.systemUsers, state)
  ),
  on(SystemUserActions.clearSystemUsers,
    state => adapter.removeAll(state)
  ),
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
